import { memo } from 'react'

import Footer, { TEST_ID } from './Footer'

const FooterComponent = memo(Footer)

export { TEST_ID }

export default FooterComponent
